class LoyaltyNavigation extends window.PURELEI.CustomElement() {
  constructor () {
    super()

    this.targets = this.getScrollTargets()
  }

  connectedCallback () {
    super.connectedCallback()

    this.onScroll()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    this.scrollToSection = this.scrollToSection.bind(this)

    this.els.tab?.elements.forEach((tab) => {
      this.listeners.add(tab, 'click', this.scrollToSection)
    })

    if (this.targets) {
      this.listeners.add(window, 'scroll', this.onScroll)
    }
  }

  getScrollTargets () {
    return this.els.tab?.elements
      .map((tab) => {
        const element = document.querySelector(`#${tab.dataset.target}`)
        return {
          element,
          top: element.offsetTop,
        }
      })
      .reverse()
  }

  onScroll () {
    const top = document.documentElement.scrollTop - this.scrollOffset

    const currentElement = this.targets?.find(
      (target) => target.top <= top,
    )?.element

    if (!currentElement) return

    const matchingTab = this.els.tab?.elements.find(
      (tab) => tab.dataset.target === currentElement.id,
    )

    if (!matchingTab) return

    this.els.tab.elements.forEach((tab) =>
      tab.classList.remove('sec-LoyaltyNavigation_Item-active'),
    )
    matchingTab.classList.add('sec-LoyaltyNavigation_Item-active')

    document
      .querySelector('.sec-LoyaltyNavigation_Items')
      .scrollTo({ left: matchingTab.offsetLeft - 16, behavior: 'smooth' })
  }

  scrollToSection (e) {
    e.preventDefault()

    const button = e.target.closest(this.els.tab.selector)
    const target = document.querySelector(`#${button.dataset.target}`)

    if (!target) return false

    const top =
      target.getBoundingClientRect().top + window.scrollY + this.scrollOffset

    window.scrollTo({ top, behaviour: 'smooth' })
  }

  get scrollOffset () {
    const headerHeight =
      document.querySelector('.hd-Header')?.clientHeight || 0
    const navigationHeight =
      document.querySelector('.sec-LoyaltyNavigation')?.clientHeight || 0

    return -(headerHeight + navigationHeight)
  }
}

if (!customElements.get('loyalty-navigation')) {
  customElements.define('loyalty-navigation', LoyaltyNavigation)
}
